// extracted by mini-css-extract-plugin
export default {"cta":"GradientCta_cta__ds0hN","arrow":"GradientCta_arrow__7S+bI"};